var map = {
	"./1.png": "0cbc",
	"./2.png": "f5b8",
	"./3.png": "d256",
	"./4.png": "d5dc",
	"./5.png": "39d1",
	"./6.png": "3590",
	"./7.png": "a2af",
	"./8.png": "292c",
	"./about-1.png": "a68a",
	"./about-2.png": "a159",
	"./about-3.png": "d459",
	"./slider-re-1.png": "9f4e",
	"./slider1.png": "9a23",
	"./slider2.png": "df08",
	"./slider_p_default.png": "c816",
	"./v-1.png": "308b",
	"./v-2.png": "e682",
	"./v-3.png": "ef24",
	"./v-4.png": "538f",
	"./v-5.png": "44bb",
	"./v-6.png": "b62d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c15";